module.exports = firebase =>
// Copy and paste this into your JavaScript code to initialize the Firebase SDK.
// You will also need to load the Firebase SDK.
// See https://firebase.google.com/docs/web/setup for more details.

firebase.initializeApp({
  "apiKey": "AIzaSyA2bhm8_n18_VPqP2TQGtOrpAuwyWZZ_4Y",
  "databaseURL": "https://squawk-868c7.firebaseio.com",
  "storageBucket": "squawk-868c7.appspot.com",
  "authDomain": "squawk-868c7.firebaseapp.com",
  "messagingSenderId": "340493820814",
  "projectId": "squawk-868c7"
});




// WEBPACK FOOTER //
// ./fire/setup.js